export default [
  {
    path: '/backend/integration-check',
    name: 'backend.integration-check',
    component: () => import(/* webpackChunkName: "IntegrationCheck" */ './IntegrationCheck')
  }
]
